<template>
  <div>
    <div class="campaign-card">
      <div>
        <div class="campaign-card-header">
          <h4 class="campaign-title">{{ projectTitle }}</h4>
          <p
            class="campaign-subtitle inter"
            v-if="projectInfo.enableCustomSubheading"
          >
            {{
              projectInfo.adminOrderSubheading ||
                `Complete form to receive a gift from ${projectInfo.teamName}.`
            }}
          </p>
          <p class="campaign-subtitle inter" v-else>
            Complete form to receive a gift from {{ projectInfo.teamName }}.
          </p>
        </div>

        <div class="campaign-card-body">
          <div class="campaign-subtitle-container">
            <p class="campaign-subtitle inter">Review</p>
            <p class="campaign-subtitle info inter">
              Review your information and submit form.
            </p>
            <p class="campaign-subtitle info inter">
              If you’d like to make changes select Edit/
              <br class="md:hidden" />Change or go back.
            </p>
          </div>

          <div class="shipping-container">
            <div class="title">
              <p>Shipping address</p>
              <button
                @click="$router.push({ name: 'AddressCollectionRecipient' })"
              >
                Edit
              </button>
            </div>

            <div class="address-detail">
              <p>{{ recipientInfo.name }}</p>
              <p>{{ recipientInfo.email }}</p>
              <p>{{ recipientInfo.addressOne }}</p>
              <p v-if="recipientInfo.addressTwo">
                {{ recipientInfo.addressTwo }}
              </p>
              <p>{{ locationDetail }}</p>
            </div>
          </div>
          <div class="products-container">
            <div class="products-container-card">
              <div class="title">
                <p>Products</p>
                <button
                  @click="$router.push({ name: 'ProjectItemsSelection' })"
                >
                  Change
                </button>
              </div>

              <div
                class="product-container grid grid-cols-1 md:grid-cols-3"
                v-if="!!selectedProducts.length"
              >
                <div
                  class="product"
                  v-for="(product, index) in selectedProducts"
                  :key="index"
                >
                  <div class="product-image">
                    <img
                      :src="product.admin_order_product_attachments[0].url"
                      alt="product image"
                      class="image"
                    />
                    <!-- <HEICImage :product="product" /> -->
                  </div>
                  <div class="product-details">
                    <div class="flex flex-col gap-1">
                      <div class="product-detail">
                        <p>{{ product.name | capitalize }}</p>
                      </div>
                      <div class="product-detail">
                        <p>
                          {{ product.price ? `$${product.price}` : '&nbsp;' }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="product-detail"
                      v-if="
                        product.option && Object.keys(product.option).length > 0
                      "
                    >
                      <p class="capitalize">
                        {{ getFormattedOptions(product.option) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="button-region flex">
              <button
                class="button-gemnote button-gemnote--small edit"
                @click="handleBack"
              >
                <span>back</span>
              </button>
              <button
                :disabled="pendingSubmission"
                class="button-gemnote button-gemnote--small"
                @click="handleSubmit"
              >
                <span>submit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts, handleBrokenImage } from '@/helpers'
import HEICConversion from '../../mixins/HEICConversion'
// import HEICImage from '../Universal/HEICImage.vue'
export default {
  props: ['uuid'],
  mixins: [HEICConversion],
  // components: { HEICImage },
  data: () => ({
    handleBrokenImage: handleBrokenImage,
    selectedProducts: [],
    pendingSubmission: false
  }),
  computed: {
    ...mapState({
      recipientInfo: state => state.project.recipientInfo,
      projectInfo: state => state.project.projectInfo
    }),

    locationDetail() {
      let location = ''
      if (this.recipientInfo.city) {
        location = `${this.recipientInfo.city}, ${this.recipientInfo.state} ${this.recipientInfo.zipcode}`
      } else {
        location = `${this.recipientInfo.state} ${this.recipientInfo.zipcode}`
      }

      return location
    },
    projectTitle() {
      return (
        (this.projectInfo &&
          this.projectInfo.enableCustomTitle &&
          this.projectInfo.adminOrderTitle) ||
        "Hurray! You're getting a gift."
      )
    },
    getFormattedOptions() {
      return option => {
        return Object.entries(option)
          .map(([key, value]) =>
            key !== 'default' && value !== 'Standard' ? `${value}` : ''
          )
          .filter(Boolean)
          .join(', ')
      }
    }
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.ADDRESS_COLLECTION)
    let projectRecipientInfo = localStorage.getItem('projectRecipientInfo')
    if (projectRecipientInfo) {
      const parsedInfo = JSON.parse(projectRecipientInfo)
      this.$store.commit('project/UPDATE_RECIPIENT_INFO', parsedInfo)
    }
  },

  mounted() {
    this.handlePersistedData()
  },

  methods: {
    handleBack() {
      this.$router.push({ name: 'AddressCollectionRecipient' })
    },

    async handleSubmit() {
      this.pendingSubmission = true
      await this.$store.dispatch('project/confirmRecipientInfo', this.uuid)
      this.pendingSubmission = false
    },

    handlePersistedData() {
      const selectedItems = JSON.parse(
        localStorage.getItem('adminOrderSelectedItems')
      )
      if (selectedItems) this.selectedProducts = selectedItems
    },

    getOptions(option) {
      let options = []
      for (let key in option) {
        if (option[key]) {
          const capitalizedKey =
            option[key].charAt(0).toUpperCase() + option[key].slice(1)
          options.push(capitalizedKey)
        }
      }
      return options.join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';
.bold {
  font-weight: bold !important;
}
.holder {
  width: 85%;
  margin: auto;
  padding: 4rem 0 8rem 0;

  .text {
    p {
      text-align: center;
      font-weight: 400;
    }
  }

  .address-region {
    padding-top: 2rem;
    width: 80%;
    margin: auto;
  }

  .card-holder {
    border: 1px solid #232220;
    padding: 2.5rem;
    margin-bottom: 1.5rem;

    .content-holder {
      display: flex;
      justify-content: space-between;

      .address-text {
        font-size: 0.875rem;
      }

      .address-detail {
        width: 50%;
        text-align: left;

        p {
          font-size: 0.813rem;
          line-height: 23px;
          word-wrap: break-word;
          width: 90%;
        }
      }
    }
  }

  .edit-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: inherit;
    border: 1px solid #232220;
    height: 30px;
    color: #232220;
    font-size: 0.813rem;
    text-transform: uppercase;
    padding: 0 1rem;
    border-radius: 44px;
  }
}

table {
  width: 100%;
  margin-top: 1.5rem;
  border-spacing: 0px;
  border-collapse: separate;

  thead > tr > th {
    color: $main-6;
    text-align: center;
    padding: 1rem 0rem;
    font-size: 0.813rem;
    border-bottom: 1px solid $onyx;

    &:nth-child(4) {
      text-align: left;
    }
  }

  tbody > tr > td {
    color: $main-6;
    text-align: center;
    padding: 0.5rem 0rem;
    font-size: 0.813rem;
    border-bottom: 1px solid $onyx;
    width: 7rem;
    max-width: 7rem;

    tfoot > tr > td {
      padding-top: 3rem;
    }

    &:nth-child(4) {
      text-align: left;
    }

    &.blank {
      width: 2rem;
    }
  }
}
tr:last-child td {
  border: none;
}

.img-holder {
  width: 98px;
  height: 98px;
  max-width: 100%;
  margin: auto;

  img {
    width: inherit;
    height: inherit;
    object-fit: contain;
  }
}
.image {
  height: 100px !important;
}
.button-region {
  width: 60%;

  @media (max-width: 575.98px) {
    width: 80%;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    width: 80%;
  }
  .button-gemnote {
    height: 2.5rem;
    width: auto;
    padding: 0 2rem;
  }
}
@media (max-width: 860px) {
  .content-holder {
    flex-direction: column;
  }
  .holder .card-holder .content-holder .address-detail {
    width: 100%;
  }
  .address-header {
    display: flex;
  }
  .edit-button {
    margin-top: 12px;
  }
  .content-holder-mobile {
    flex-direction: row !important;
  }
  .holder {
    width: 90%;
  }
  .edit-button {
    margin-top: 0;
  }
  // .image {
  //   height: auto !important;
  // }
}

.campaign-card {
  min-width: 100%;
  margin: 0 auto;
  padding: 2rem 0rem;
  padding-bottom: 8rem;
}

.campaign-card-body {
  margin: 1.5rem 0;
  border: 1px solid $main-5;
  border-radius: 1rem;
  padding: 2rem 0;

  .campaign-subtitle-container {
    border-bottom: 1px solid $main-5;
    padding-bottom: 3.5rem;
  }

  .campaign-subtitle {
    font-weight: 700;
    font-size: 1.563rem;
    text-align: center;
    margin-bottom: 0.5rem;

    &.info {
      font-size: 0.938rem;
      font-weight: 400;
      margin-bottom: 0;
    }
  }

  .campaing-card-indicators {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;

    .campaing-card-indicators-item {
      width: 44px;
      height: 5px;
      border-radius: 100px;
      background-color: $main-1;
      cursor: pointer;

      &.active {
        background-color: $main-5;
      }
    }
  }
}

.campaign-card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;

  @media (max-width: 575.98px) {
    justify-content: center;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  .campaign-subtitle {
    font-size: 0.938rem;
    text-align: left;
  }
}

.campaign-title {
  font-family: 'Editorial New';
  font-size: 2.5rem;
  font-weight: normal;
  text-align: left;
}

.campaign-subtitle {
  font-size: 1rem;
  text-align: center;
}

.shipping-container {
  padding-top: 2rem;
  width: 70%;
  margin: auto;

  @media (max-width: 575.98px) {
    width: 90%;
  }

  .title {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    margin-bottom: 1rem;

    p {
      font-size: 0.938rem;
      font-weight: 700;
    }
    button {
      font-size: 0.75rem;
      text-decoration: underline;
    }
  }
  .address-detail {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    p {
      font-size: 0.938rem;
      text-align: left;
    }
  }
}

.products-container {
  border-top: 1px solid $main-5;
  margin-top: 2rem;

  .products-container-card {
    padding: 2rem 0;
    width: 70%;
    margin: auto;

    @media (max-width: 575.98px) {
      width: 90%;
    }

    .title {
      display: flex;
      align-items: center;
      gap: 0.6rem;
      margin-bottom: 1rem;

      p {
        font-size: 0.938rem;
        font-weight: 700;
      }
      button {
        font-size: 0.75rem;
        text-decoration: underline;
      }
    }
    .product-container {
      display: grid;
      // border-bottom: 1px solid $main-5;
      margin-top: 1.5rem;
      .product {
        border-right: 1px solid $main-5;
        border-bottom: 1px solid $main-5;
        border-left: 1px solid $main-5;
        border-top: 1px solid $main-5;

        @media (max-width: 768px) {
          border-right: none;
        }
        @media (max-width: 992px) {
          padding: 1rem;
        }

        display: flex;
        align-items: flex-start;
        gap: 0.8rem;
        padding: 1rem 0;

        .product-image {
          display: flex;
          justify-content: flex-start;

          @media (min-width: 992px) {
            padding-left: 1rem;
          }

          img {
            height: 150px;
            width: 120px;
            object-fit: contain;
          }
        }

        .product-details {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          align-items: flex-start;

          .product-detail {
            text-align: left;
            p {
              font-size: 0.938rem;
            }
          }
        }
        // &:nth-child(3n) {
        //   border-right: none;
        // }

        // &:nth-last-child(-n + 2) {
        //   border-bottom: none;
        // }

        // @media (max-width: 768px) {
        //   &:nth-last-child(-n + 2) {
        //     border-bottom: 1px solid $main-5;
        //   }
        //   &:last-child {
        //     border-bottom: none;
        //   }
        // }
      }
    }
  }
  .button-region {
    margin: 1.5rem 0;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 0.8rem;

    button {
      padding: 1rem 2.5rem !important;
      height: 2.8rem !important;

      &.edit {
        background-color: transparent !important;
        color: #232220 !important;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>
